import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'

export interface BookingExtraTranslation {
  _id?: ID
  booking_extra_id?: ID;
  language: string;
  title: string;
}

export interface BookingExtra {
  _id?: ID;
  translations: BookingExtraTranslation[];
  type?: 'checkbox' | 'radio' | 'text';
  category?: string;
  isActive?: boolean;
  hotels?: string[];
  order?: number;
}

export const initialBookingExtra: BookingExtra = {
  translations: [
    {
      language: 'en',
      title: '',
    },
  ],
  type: 'checkbox',
  category: '',
  isActive: true,
  hotels: [],
  order: 0,
};

export type BookingExtrasQueryResponse = Response<Array<BookingExtra>>;
export type QueryResponseBookingExtraContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createBookingExtraResponseContext<T>(initialState: QueryResponseBookingExtraContextProps<T>) {
  return createContext(initialState)
}
export const initialBookingExtraQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }
